import { Dropdown } from '@appd/uik';
import { CSSProperties } from 'react';

interface DashifyDropdownOption<T> {
  value: T;
  label: string;
  url: string;
}

interface DashifyDropdownProps<T> {
  label: string;
  kind?: 'PRIMARY' | 'MACRO' | 'MENU_ITEM' | 'MENU' | 'SECONDARY' | 'SUBMIT' | 'TERTIARY' | undefined;
  onClick: (option: DashifyDropdownOption<T>) => void; // Handle selecting an option
  options: DashifyDropdownOption<T>[]; // Ensure options use generic type T for value
  placeholder: string;
  className: string;
  style?: CSSProperties;
}

export const DashifyDropdown = <T extends string | number>({
  label,
  onClick,
  options = [],
  kind = 'SECONDARY',
  placeholder = 'Select a value',
  className,
  style,
}: DashifyDropdownProps<T>) => {
  return (
    <Dropdown kind={kind} label={label} placeholder={placeholder} className={className} style={style}>
      {options.map(option => (
        <Dropdown.Option key={option.value} onClick={() => onClick(option)}>
          {option.label}
        </Dropdown.Option>
      ))}
    </Dropdown>
  );
};
